<div class="display-grid ml-10 color-accent">
  <span class="footer">wersja: {{ version }}</span>
</div>
